module.exports = __webpack_public_path__ + "img/skypets-1.f9902663.jpg";